<template>
	<div data-test="asset-element-list">
		<div class="display-flex flex-direction-column gap-100">
			<AssetElementCard
				v-for="assetElement in paginatedData"
				:key="`${assetElement.elementType}-${assetElement.fundriseId}`"
				:asset-element="assetElement"
			/>
		</div>

		<ListPaginator v-model:paginator="paginator" :enable-boundaries="true" @paginated="onPagination" />
	</div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { Asset } from 'types/assets';
import AssetElementCard from '@components/asset-element/asset-element-card.vue';
import ListPaginator from '@components/layout/list-paginator.vue';
import Paginator from '@classes/Paginator';

interface Props {
	assetElements: Array<Asset>;
	assetElementsPerPage?: number;
}

interface Emits {
	(e: 'paginated'): void;
}

const props = withDefaults(defineProps<Props>(), {
	assetElementsPerPage: 8,
	sortMethod: undefined
});

const emits = defineEmits<Emits>();

const paginator = ref(new Paginator(0, props.assetElementsPerPage, props.assetElements.length));

const paginatedData = computed(
	(): Array<Asset> => props.assetElements.slice(paginator.value.start, paginator.value.end)
);

watch(
	() => props.assetElements,
	(): void => {
		paginator.value = new Paginator(0, props.assetElementsPerPage, props.assetElements.length);
	}
);

function onPagination(): void {
	emits('paginated');
}
</script>
